import { modifier } from 'ember-modifier';

const toggleScrolledClass = (element: HTMLElement) => {
	const update = () => {
		element.classList.toggle('is-scrolled', element.scrollTop > 0);
	};

	update();
	element.addEventListener('scroll', update, { passive: true });

	return () => {
		element.removeEventListener('scroll', update);
	};
};

const toggleScrolledClassModifier = modifier(toggleScrolledClass);

export default toggleScrolledClassModifier;
